import React from "react";
import { Phone, CheckCircle2, MapPinned } from "lucide-react";
import { PACKAGES, CONTACT } from "../mock";
import { Button } from "../components/ui/button";

const Packages = () => {
  return (
    <section id="packages" className="py-20 bg-[#fffaf3]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-amber-600 font-medium tracking-widest uppercase text-sm">
            Our Packages
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-orange-900 mt-2">
            Hyderabad to Srisailam Tour Packages
          </h2>
          <div className="mx-auto mt-4 h-1 w-24 rounded-full bg-gradient-to-r from-amber-400 to-orange-600" />
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {PACKAGES.map((pkg) => (
            <div
              key={pkg.id}
              className="group rounded-3xl overflow-hidden bg-white shadow-lg hover:shadow-2xl transition-all duration-300 border border-amber-100 flex flex-col"
            >
              <div className="relative h-60 overflow-hidden">
                <img
                  src={pkg.image}
                  alt={pkg.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <div className="absolute bottom-4 left-5 right-5 text-white">
                  <h3 className="font-display text-2xl">{pkg.title}</h3>
                  <p className="text-sm text-amber-100">{pkg.subtitle}</p>
                </div>
              </div>

              <div className="p-6 flex flex-col flex-1">
                <p className="text-orange-700 font-medium mb-4 flex items-center gap-2">
                  <MapPinned className="h-4 w-4" /> {pkg.tagline}
                </p>
                <div className="grid grid-cols-2 gap-x-4 gap-y-2 mb-6">
                  {pkg.highlights.map((h) => (
                    <div
                      key={h}
                      className="flex items-start gap-2 text-sm text-stone-700"
                    >
                      <CheckCircle2 className="h-4 w-4 text-green-600 mt-0.5 shrink-0" />
                      {h}
                    </div>
                  ))}
                </div>
                <a href={`tel:+91${CONTACT.primary}`} className="mt-auto">
                  <Button className="w-full bg-orange-600 hover:bg-orange-700 text-white rounded-full gap-2">
                    <Phone className="h-4 w-4" /> Enquire Now
                  </Button>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Packages;
